<template>
  <div class="full-area">
    <header
      class="question-header"
      :class="{'align-bottom': randomizedOptions > 2}"
    >
      <h2>{{data.fields.questionTitle}}</h2>
    </header>
    <content class="content delay-entry short-delay">
      <div class="grid-wrapper">
        <div
          :span="12"
          v-for="value in randomizedOptions"
          :key="value"
          class="binary-box"
          :class="{'selected-box': form.selected[0] === value}"
          @click="selectThis(value)"
        >
          <div class="center-me">
            {{value}}
          </div>
        </div>
      </div>
    </content>
    <footer>
      <SkipQuestionButton
        :location="'locate-bottom'"
        v-on:skip="selectThis('NS/NR')"
      ></SkipQuestionButton>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Dilemma',

  props: [ 'data' ],

  components: {
    SkipQuestionButton: () => import('Components/base/SkipQuestionButton')
  },

  data () {
    return {
      form: {
        question: this.data.fields.questionTitle,
        id: this.data.sys.id,
        selected: [],
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      }
    }
  },

  computed: {
    randomizedOptions () {
      const options = this.data.fields.textOptions.slice(0)
      return options.sort(function () { return 0.5 - Math.random() })
    }
  },

  methods: {
    selectThis (item) {
      this.form.selected = [item]
    },
    next () {
      this.form.timestamps.finish = new Date()
      this.calculateScores()
      this.$emit('next', this.form)
    },
    validInput (value) {
      // Add simple validation: if it exists, it is valid.
      if (value) {
        this.form.timestamps.valid = new Date()
        this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
        return true
      } else {
        return false
      }
    },
    calculateScores () {
      if (!this.data.fields.formula) {
        return
      }
      this.$store.dispatch('CALCULATE_WEIGHTED_QUESTION', {
        formula: this.data.fields.formula,
        selected: this.form.selected,
        options: this.data.fields.textOptions,
        maxAnswers: 1
      }).then(scores => {
        this.form.weighted = scores.weighted.slice(0)
        this.form.weightedMin = scores.weightedMin
        this.form.weightedMax = scores.weightedMax
      }).catch(err => {
        console.log('err: ', err)
      })
    }
  },

  watch: {
    // Add a simple watch to trigger next automatically after some ms
    'form.selected': function (newVal, oldVal) {
      if (this.validInput(newVal)) {
        setTimeout(() => {
          this.next()
        }, 200)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .grid-wrapper {
    padding-top: -100px;
  }

  .center-me {
    display: flex;
    flex: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    justify-content: center;
    align-items: center;
    padding: 5px;
  }

  .selected-box {
    animation: standOut 0.4s ease-in-out forwards;
    background-color: $color-emphasis-alt;
  }
</style>
